import './App.scss';
import Menu from './Menu';
import { Outlet } from 'react-router-dom';
import { AccountsProvider } from './AccountsContext';

function App() {
  return (
    <div id="app">
      <AccountsProvider>
        <div className="menu-and-page">
          <Menu/>
          <div className="page">
            <Outlet/>
          </div>
        </div>
      </AccountsProvider>
    </div>
  );
}

export default App;
